import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    noData: '没有数据',
    selectAll: '选择全部',
    unselectAll: '取消选择全部',
    selectRow: '选择本行',
    deselectRow: '取消选择本行',
    expandRow: '展开本行',
    collapseRow: '收起本行',
    loading: '数据加载中…',
    apply: '应用',
    clear: '清空'
  },
  {
    ns: 'table'
  }
)
